import { _ } from "../../core/polyglot/polyglot.js";
import Model from "../Model.js";

/**
 * `KeyFigureCategory` is a simple data-object used to represent a category of KeyFigures.
 *
 * @param {string} spec.name - name of the category
 * @param {KeyFigure[]} [spec.items] - key-figures in the category
 * @param {string} spec.group - group name used to gather the categories
 */
export default class KeyFigureCategory extends Model {
	constructor({ name, items = [], group }) {
		super(arguments);

		this._name = name;
		this._items = items;
		this._group = group;
	}

	getName() {
		return this._name;
	}

	getItems() {
		return this._items;
	}

	addItem(item) {
		this._items.push(item);
	}

	getGroup() {
		return this._group;
	}

	static fromPresets(presets) {
		const presetCategories = {};

		presets
			.sort((a, b) => {
				if (a.getName() === b.getName()) return 0;
				return a.getName() > b.getName() ? 1 : -1;
			})
			.forEach((preset) => {
				presetCategories[preset.getName()] = new this({
					name: preset.getName(),
					items: preset.getKeyFigures(),
					group: _("Presets"),
				});
			});

		return presetCategories;
	}

	static createCategoriesFromKeyFigures(keyFigures) {
		const categories = new Map();

		const addItemToCategory = (keyFigure) => {
			const groupName = keyFigure.getGroup().toString();
			let category = categories.get(groupName);

			if (!category) {
				category = this._fromBASGroupName(groupName);
				categories.set(groupName, category);
			}

			category.addItem(keyFigure);
		};

		keyFigures.forEach(addItemToCategory);

		return [...categories.values()];
	}

	static _fromBASGroupName(name) {
		return new this({ name, group: _("BAS Groups") });
	}
}
